'use client';

import posthog from 'posthog-js';

type CaptureProperties = Record<string | number, unknown>;

export function capturePostHogException(
  error: Error & { digest?: string },
  properties: CaptureProperties,
) {
  try {
    posthog.captureException(error, {
      ...properties,
      digest: error.digest ?? null,
      pathname: typeof window !== 'undefined' ? window.location.pathname : null,
      search: typeof window !== 'undefined' ? window.location.search : null,
    });
  } catch (captureError) {
    console.error('[PostHog] Failed to capture client exception', captureError);
  }
}
